/* @flow */

// TODO: There is a copy of this file, shared/src/utils/BasketUtil.ts, which has already
//   diverged from the original! -> Align both versions and migrate all places to using
//   the version of the two diverged copies, which is maintained in "shared"!

// This is currently dirty, but I know of no other solution as we just know the weight in the basket,
// when we do the sync from our AddToBasketButton to ShoppingCart.
import { BuyabilityRenderData } from "shared/src/types/articlesearch/Article";

export function canNotBeAddedToBasket(
    isDeprecated: boolean,
    isNonExistentBundle: boolean,
    isCartEnabled: boolean,
    buyability: BuyabilityRenderData
): boolean {
    return (!buyability.customer && !buyability.employee) || isDeprecated || !isCartEnabled || isNonExistentBundle;
}
